var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullpushclicked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 0.800781,
    width: 43.4019,
    height: 43.4019,
    rx: 6,
    fill: "#F0EFFB"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2724_18251)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_18251",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6719 12.5H32.6719V32.5H12.6719V12.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_18251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9134 19.5063C27.1519 18.5388 25.8556 18.2584 24.7934 18.7603C24.2025 18.1475 23.38 17.8819 22.5826 17.9935V15.1172C22.5826 13.6741 21.4211 12.5 19.9933 12.5C18.5656 12.5 17.404 13.6741 17.404 15.1172V21.4113C16.6263 21.1218 15.7137 21.2123 14.9789 21.7578C13.8322 22.6092 13.5807 24.2318 14.4106 25.3966L18.6957 31.4123C19.1809 32.0934 19.9665 32.5 20.7969 32.5H27.7612C28.9644 32.5 30.0102 31.6602 30.283 30.4767L31.3544 25.8283C31.3768 25.7309 31.3937 25.6325 31.4049 25.5332C31.4162 25.4339 31.4219 25.3343 31.4219 25.2344V21.9531C31.4219 20.1233 29.6006 18.8565 27.9134 19.5063ZM17.0854 23.4257L18.145 24.9131C18.4963 25.4063 19.279 25.1587 19.279 24.5505V15.1172C19.279 14.1359 20.7075 14.1344 20.7075 15.1172V21.9531C20.7075 22.2983 20.9874 22.5781 21.3325 22.5781H21.6004C21.9456 22.5781 22.2254 22.2983 22.2254 21.9531V20.5859C22.2254 19.6047 23.654 19.6031 23.654 20.5859V21.9531C23.654 22.2983 23.9338 22.5781 24.279 22.5781H24.5469C24.8921 22.5781 25.1719 22.2983 25.1719 21.9531V21.1328C25.1719 20.1516 26.6005 20.15 26.6005 21.1328V21.9531C26.6005 22.2983 26.8803 22.5781 27.2255 22.5781H27.4933C27.8385 22.5781 28.1183 22.2983 28.1183 21.9531C28.1183 20.9718 29.5469 20.9703 29.5469 21.9531V25.2344C29.5469 25.2925 29.5403 25.3507 29.5273 25.4071L28.4558 30.0556C28.3785 30.3909 28.0929 30.625 27.7612 30.625H20.7969C20.5715 30.625 20.3569 30.5126 20.2228 30.3243L15.9372 24.3087C15.3744 23.5188 16.5229 22.6361 17.0854 23.4257ZM20.8025 28.125V24.375C20.8025 24.0298 21.0473 23.75 21.3493 23.75H21.5837C21.8857 23.75 22.1306 24.0298 22.1306 24.375V28.125C22.1306 28.4702 21.8857 28.75 21.5837 28.75H21.3493C21.0473 28.75 20.8025 28.4702 20.8025 28.125ZM23.7489 28.125V24.375C23.7489 24.0298 23.9937 23.75 24.2958 23.75H24.5301C24.8322 23.75 25.077 24.0298 25.077 24.375V28.125C25.077 28.4702 24.8322 28.75 24.5301 28.75H24.2958C23.9937 28.75 23.7489 28.4702 23.7489 28.125ZM26.6953 28.125V24.375C26.6953 24.0298 26.9402 23.75 27.2422 23.75H27.4766C27.7786 23.75 28.0235 24.0298 28.0235 24.375V28.125C28.0235 28.4702 27.7786 28.75 27.4766 28.75H27.2422C26.9402 28.75 26.6953 28.4702 26.6953 28.125Z",
    fill: "#9333EA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2724_18251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12.6719 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullpushclicked);
export default __webpack_public_path__ + "static/media/fullpushclicked.fea67f53aa5bee887edc6bdb751251d5.svg";
export { ForwardRef as ReactComponent };